import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

var _excluded = ["placement", "className", "children", "label", "content", "triggerClassName"];
var Trigger = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    className: className
  }, children);
});
var Tooltip = function Tooltip(props) {
  var placement = props.placement,
    className = props.className,
    children = props.children,
    label = props.label,
    content = props.content,
    triggerClassName = props.triggerClassName,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React.createElement(Tippy
  // to debug styles, add prop to Tippy trigger="click"
  , _extends({
    arrow: true,
    content: content || label,
    className: className,
    placement: placement,
    theme: "pico"
  }, rest), /*#__PURE__*/React.createElement(Trigger, {
    className: triggerClassName
  }, children));
};
var TooltipPropTypes = {
  children: PropTypes.node,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left', 'top-start', 'top-end', 'right-start', 'right-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end', 'auto', 'auto-start', 'auto-end']),
  triggerClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
Tooltip.propTypes = Object.assign({}, TooltipPropTypes);
Tooltip.defaultProps = {
  className: '',
  placement: 'auto',
  triggerClassName: ''
};

export { TooltipPropTypes, Tooltip as default };
//# sourceMappingURL=index.js.map
